module.exports = __webpack_public_path__ + "img/green_075.d6a93040.png";